import { IPart, IPartDetails } from 'parts/types';

// Bridges search-result IPart → IPartDetails so Subtitle can render immediately, before
// useGetPart returns the full record. Fields IPart doesn't carry (isProprietary, etc.)
// stay undefined until partRecord lands.
export const partToPartDetails = (part: IPart): IPartDetails => ({
  id: part.id,
  number: part.number,
  categories: part.categories,
  description: part.description,
  descriptionLong: part.descriptionLong,
  engineeringNumber: part.engineeringNumber,
  orderingNumber: part.orderingNumber,
  familyId: part.familyId,
});
